/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronsOutsideVertically: {
  name: 'chevrons-outside-vertically';
  data: string;
} = {
  name: 'chevrons-outside-vertically',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.354.646a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L8 1.707l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4Zm4 10.708-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L8 14.293l3.646-3.647a.5.5 0 0 1 .708.708Z" fill="currentColor"/></svg>`,
};
